import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BllIconComponent } from './icon.component';

@NgModule({
  imports: [CommonModule],
  declarations: [BllIconComponent],
  exports: [BllIconComponent],
})
export class BllIconModule {}
